<rs-top-bar-menu
  application="MOBICLEAR"
  [menuItems]="menuItems()"
  (onLogout)="onLogout()"
/>

<rs-loader />

<router-outlet />

<rs-footer />